import { Component, HostListener, ViewChild } from "@angular/core";

import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { Credit, Member } from "app/service/member/member";
import { ShareService } from "app/service/share/share.service";
import * as moment from 'moment';
import { ModalDirective } from "ngx-bootstrap/modal";
import { AuthService } from "../../../service/auth/auth.service";
import { GtmService } from "../../../service/gtm/gtm.service";
import { ReservationTable, Room, RoomReservation } from "../../../service/reservation/reservation";
import { ReservationService } from "../../../service/reservation/reservation.service";
import { getTimeIndex } from "../reservation";


@Component({
  selector: 'app-reservation-rooms',
  templateUrl: './rooms.component.html',
  styleUrls: ['./rooms.component.scss'],
  providers: [ShareService, ReservationService, DatePipe]
})
export class ReservationRoomsComponent {
  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerHeight = window.innerHeight - (window.innerWidth > 768 ? 105 : 70);
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
      this.onFilterPeople(this.filterPeople)
    }
  }

  timeLeftPos: number = 0;
  onTableScroll(event) {
    this.timeLeftPos = event.target.scrollLeft
  }


  location: string;
  me: Member;
  credit: Credit;

  table;
  fixedThead;
  theadTds;
  fixedTheadTds;

  durationText = {
    'DURATION030': '30분', 'DURATION060': '1시간', 'DURATION090': '1시간 30분', 'DURATION120': '2시간'
  };
  durations: string[] = ['DURATION030', 'DURATION060', 'DURATION090', 'DURATION120'];
  dayOfTheWeeks: string[] = ['일', '월', '화', '수', '목', '금', '토'];

  startTimes: string[] = ['0800', '0830', '0900', '0930', '1000', '1030', '1100', '1130', '1200', '1230', '1300', '1330',
    '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030',
    '2100', '2130', '2200'];
  times: string[] = ['08:00', '', '09:00', '', '10:00', '', '11:00', '', '12:00', '', '13:00', '',
    '14:00', '', '15:00', '', '16:00', '', '17:00', '', '18:00', '', '19:00', '', '20:00', '',
    '21:00', '', '22:00'];
  roomTimes: string[] = ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
    '21:00', '21:30', '22:00', '22:30'];
  // 관리자 시간 선택 모듈에서 22:30분을 막을 방법이 없어서 인덱스 계산을 위해 추가

  startTimeIndex = {};
  roomTimeIndex = {};
  durationIndex = {};

  rooms: Room[];
  reservations: RoomReservation[] = [];
  reservedTable: any[][] = [];

  tablePage: number = 1;
  tableSize: number = 10;
  myReservationsCache: any[] = [];
  get myReservations(): RoomReservation[] {
    return this.myReservationsCache
      .slice((this.tablePage - 1) * this.tableSize, this.tablePage * this.tableSize);
  }
  onChangePage(page) {
    this.tablePage = page.page
  }

  innerHeight: number;
  today: string;
  lastDay: string;
  startDate: Date;
  endDate: Date;

  constructor(private shareService: ShareService,
    private reservationService: ReservationService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private gtmService: GtmService,
    private datePipe: DatePipe) {
    this.innerHeight = window.innerHeight - (window.innerWidth > 768 ? 105 : 70);
    this.isMobile = (window.innerWidth < 768);

    this.startDate = moment().toDate();
    this.endDate = moment().add(2, 'month').toDate();
    this.today = moment().format('YYYY-MM-DD');
    this.lastDay = moment().add(2, 'month').format('YYYY-MM-DD');

    let date = this.route.snapshot.queryParams["date"];
    date = date ? moment(date, 'YYYY-MM-DD').toDate() : new Date();

    this.setDate(date);

    this.startTimes.forEach((value, index) => this.startTimeIndex[value] = index);
    this.durations.forEach((value, index) => this.durationIndex[value] = index + 1);
    this.roomTimes.forEach((value, index) => this.roomTimeIndex[value] = index);

    this.shareService.awaitMe().take(1).subscribe(
      me => {
        this.me = me;
        this.location = me.location.key

        this.getRooms(date);
      }
    )

    this.shareService.awaitCredit().subscribe(
      credit => this.credit = credit
    )

    this.gtmService.pageViewWithPage({
      'path': this.route.snapshot['_routerState'].url,
      'title': 'Meeting Room',
      'breadcrumb': 'Home > Member > Meeting Room'
    });
  }

  private setDate(date: Date) {
    this.year = date.getFullYear();
    this.month = date.getMonth() + 1;
    this.day = date.getDate();
    this.dayOfTheWeek = this.dayOfTheWeeks[date.getDay()];
    this.dt = date
  }

  tblStore: ReservationTable = new ReservationTable()
  buildTableStore(rooms): ReservationTable {
    const rtn = {
      header: [],
      subHeader: [],
      roomsByBsc: {},
      rooms: [],
      subHeaderSize: 44,
    }
    const { roomsByBsc } = rtn

    rooms.map(item => {
      if (roomsByBsc[item.bsc_num] === undefined) {
        roomsByBsc[item.bsc_num] = []
      }
      roomsByBsc[item.bsc_num].push(item)
    })

    for (let key in roomsByBsc) {
      // 공간 정렬
      roomsByBsc[key].sort((a, b) => {
        if (a.floor < b.floor) return -1;
        else if (a.floor === b.floor && a.room < b.room) return -1;

        return 1;
      })

      rtn.header.push({
        text: `${key}인`,
        count: roomsByBsc[key].length,
        filter: parseInt(key) < 8 ? '4_6' : '8_28',
      })

      roomsByBsc[key].map(item =>
        rtn.subHeader.push({
          text: `${parseInt(item.floor)}F${/[a-zA-Z]/.test(item.room[3]) ? `-${item.room[3]}` : ''}`,
          filter: parseInt(key) < 8 ? '4_6' : '8_28',
        })
      )

      rtn.rooms = rtn.rooms.concat(roomsByBsc[key])
    }

    const getScrollbarWidth = function (recalculate) {
      var div1, div2;
      div1 = document.createElement('div');
      div2 = document.createElement('div');
      div1.id = "div1";
      div2.id = "div2";
      div1.style.width = div2.style.width = div1.style.height = div2.style.height = '100px';
      div1.style.overflow = 'scroll';
      div2.style.overflow = 'hidden';
      document.body.appendChild(div1);
      document.body.appendChild(div2);
      let scrollbarWidth = Math.abs(div1.scrollHeight - div2.scrollHeight);
      div1.remove();
      div2.remove();
      return scrollbarWidth;
    }();

    const tableWidth = 927 - 47 - getScrollbarWidth // 테이블 폭, 시간 셀 폭, 스크롤 폭

    // 테이블 폭보다 작은 경우 셀 크기 조정
    if (!this.isMobile && tableWidth > rtn.subHeader.length * rtn.subHeaderSize) {
      rtn.subHeaderSize = Math.floor(tableWidth / rtn.subHeader.length)
    }

    return rtn
  }

  getRooms(date: Date | undefined) {
    let dateObj = date || new Date();
    let dateTxt = moment(dateObj).format('YYYY-MM-DD')

    this.reservationService.getRooms(this.location, dateTxt).take(1).subscribe(
      rooms => {
        this.tblStore = this.buildTableStore(rooms)
        this.rooms = this.tblStore.rooms

        this.getReservations();
        this.getMyReservation();
      }
    );
  }

  private getReservations() {
    this.reservationService.getReservationsRooms(this.location, this.onGetDate()).take(1).subscribe(
      reservations => {
        this.tablePage = 1;
        this.reservedTable = [];
        this.reservations = reservations;
        // console.log(this.reservations)

        this.reservations.forEach(reservation => {
          const [startTimeIndex, endTimeIndex] = getTimeIndex(reservation);

          for (let i = startTimeIndex; i <= endTimeIndex; i++) {
            if (!this.reservedTable[reservation.pblspc_cd]) this.reservedTable[reservation.pblspc_cd] = [];
            this.reservedTable[reservation.pblspc_cd][i] = {
              'reservation': reservation,
              'Top': startTimeIndex === i,
              'Bottom': endTimeIndex === i,
              'drawTop': !!i
            };
          }
        });

        this.makeTableCells();
      }
    );
  }

  private getMyReservation() {
    this.reservationService.getMyReservationsRooms(this.location).take(1).subscribe(
      reservations => this.myReservationsCache = reservations
    )
  }

  filterPeople: string = '4_6';
  onFilterPeople(filterPeople) {
    this.filterPeople = filterPeople;

    if (this.tableCells) {
      this.tableCells = this.tableCells.map(col => {
        return col.map(item => {
          return {
            ...item,
            isShow: this.onShowBody(item.room)
          }
        })
      })
    }
  }


  holidays = [
    "0101", "0301", "0505", "0606", "0717", "0815", "1003", "1225", //양력휴일
    "0101", "0102", "0408", "0814", "0815", "0816",                 //음력휴일, 설전날도 넣어야함.
  ];

  tableCells: any[][] = []
  makeTableCells() {
    if (!this.rooms) return []
    this.tableCells = []

    this.startTimes.map((startTime) => {
      this.tableCells.push(
        this.rooms.map(room => {
          return {
            classList: this.onTableClass(startTime, room),
            isShow: this.onShowBody(room),
            room,
          }
        }
        ))
    })
  }


  isFree(startTime: string, room: Room): boolean {
    if (!this.rooms) return false;

    let rtn = true
    let n = this.startTimeIndex[startTime]

    room.policy.times.map(({ start, end }) => {
      let s = this.roomTimeIndex[start]
      let e = this.roomTimeIndex[end]

      if (rtn && (n >= s && n < e)) rtn = false
    })

    return rtn;
  }

  isPast(startTime: string): boolean {
    if (moment(`${this.onGetDate()} ${startTime}`, 'YYYY-MM-DD hhmm').diff(moment(), 'minutes') <= -10) return true;
    return false;
  }

  isReserved(startTime: string, room: Room): boolean {
    if (!this.reservations) return false;
    if (!this.reservedTable[room.cd]) return false;

    return !!this.reservedTable[room.cd][this.startTimeIndex[startTime]];
  }

  isDrawTop(startTime: string, room: Room): boolean {
    if (!this.reservations) return false;
    if (!this.reservedTable[room.cd]) return false;
    if (!this.reservedTable[room.cd][this.startTimeIndex[startTime]]) return false;

    return this.reservedTable[room.cd][this.startTimeIndex[startTime]].drawTop;
  }

  isTop(startTime: string, room: Room): boolean {
    if (!this.reservations) return false;
    if (!this.reservedTable[room.cd]) return false;
    if (!this.reservedTable[room.cd][this.startTimeIndex[startTime]]) return false;

    return this.reservedTable[room.cd][this.startTimeIndex[startTime]].Top;
  }

  isBottom(startTime: string, room: Room): boolean {
    if (!this.reservations) return false;
    if (!this.reservedTable[room.cd]) return false;
    if (!this.reservedTable[room.cd][this.startTimeIndex[startTime]]) return false;

    return this.reservedTable[room.cd][this.startTimeIndex[startTime]].Bottom;
  }

  onTableClass(startTime: string, room: Room) {
    let classList = [];
    let reservation;

    try {
      reservation = this.reservedTable[room.cd][this.startTimeIndex[startTime]].reservation;
    } catch (e) {
      reservation = null;
    }

    if (this.isFree(startTime, room)) classList.push('free')
    if (this.isPast(startTime)) classList.push('past')
    if (this.isReserved(startTime, room)) classList.push('reserved')
    if (this.isDrawTop(startTime, room)) classList.push('draw-top')
    if (this.isTop(startTime, room)) classList.push('top')
    if (this.isBottom(startTime, room)) classList.push('bottom')

    if (reservation === null) { }
    else if (reservation.email == this.me.email) classList.push('me');
    else if (reservation.clt_nm == this.me.team.name) classList.push('company');

    return classList;
  }

  onClick(startTime: string, item) {
    const { room } = item;
    let reservation = null;
    let startTimeIndex = this.startTimeIndex[startTime];
    if (this.reservations && this.reservedTable[room.cd] && this.reservedTable[room.cd][startTimeIndex]) {
      reservation = this.reservedTable[room.cd][startTimeIndex].reservation;
    }

    // 예약 가능 확인
    if (reservation == null) {
      let current = this.onGetDate();
      if (this.today > current || this.lastDay < current || item.classList.findIndex(o => o === 'active') !== -1) {
        window.alert('예약이 가능하지 않습니다.');
        return;
      }
    }

    let duration = 4;
    if (reservation == null && this.reservations) {
      duration = 0;
      for (let i = 0; i < 4; i++) {
        if (this.reservedTable[room.cd] && this.reservedTable[room.cd][startTimeIndex + i] || (startTimeIndex + i) >= this.startTimes.length - 1) {
          break;
        }
        duration = i + 1;
      }
    }

    this.calcPermitPets(room);
    this.showModal(reservation, room, startTime, duration);
  }

  onShowHeader(cond) {
    return this.filterPeople === cond || (window.innerWidth > 768);
  }
  onShowBody(room: Room) {
    if (this.filterPeople === '4_6') return room.bsc_num <= 6 || (window.innerWidth > 768);
    else if (this.filterPeople === '8_28') return (room.bsc_num >= 8 && room.bsc_num <= 28) || (window.innerWidth > 768);
  }

  getRoomName(nm, floor, size): string {
    return `${nm} (${Number(floor)}층 ${size}인실)`;
  }
  getRoomNameBycd({ pblspc_nm, pblspc_cd }): string {
    let rooms = this.rooms ? this.rooms : []
    let room = rooms.find(o => o.cd === pblspc_cd)
    if (room)
      return `${room.nm} (${Number(room.floor)}층 ${room.bsc_num}인실)`;
    else
      return `${pblspc_nm}`
  }


  ///////////////////////////////
  showCalendar: boolean = false;
  dt: Date = new Date;

  year: number;
  month: number;
  day: number;
  dayOfTheWeek: string;

  onPrevDay() {
    const date = new Date(this.year, this.month - 1, this.day - 1);
    // if (this.today > moment(date).format('YYYY-MM-DD')) {
    //   alert(`${this.today} ~ ${this.lastDay} 일정만 예약 가능합니다.`);
    //   return;
    // }

    this.router.navigate([], { queryParams: { date: moment(date).format('YYYY-MM-DD') }, replaceUrl: true });
    this.setDate(date);
    this.getRooms(date);
  }

  onNextDay() {
    const date = new Date(this.year, this.month - 1, this.day + 1);
    if (this.lastDay < moment(date).format('YYYY-MM-DD')) {
      alert(`${this.today} ~ ${this.lastDay} 일정만 예약 가능합니다.`);
      return;
    }

    this.router.navigate([], { queryParams: { date: moment(date).format('YYYY-MM-DD') }, replaceUrl: true });
    this.setDate(date);
    this.getRooms(date);
  }

  onSelectCalendar(date) {
    this.showCalendar = false;
    let ipt = date.getFullYear ? date : moment(date, 'YYYY-MM-DD').toDate();

    this.router.navigate([], { queryParams: { date: moment(ipt).format('YYYY-MM-DD') }, replaceUrl: true });
    this.setDate(ipt);
    this.getRooms(ipt);
  }


  // ////////////////////////////// Modal ///////////////////////

  @ViewChild('modal') modal: ModalDirective;
  isModalShown: boolean = false;
  reservation: RoomReservation;
  room: Room;
  startTime: string;
  duration: number;
  rsv_cache: {
    credit_by_time: {};
    time_use_end: string;
    credit: number;
  };

  showModal(reservation: RoomReservation, room: Room, startTime: string, duration: number) {
    this.reservation = reservation;
    this.room = room;
    this.startTime = startTime;
    this.duration = duration;

    this.isModalShown = true;
    this.rsv_cache = {
      credit_by_time: {},
      time_use_end: '',
      credit: 0,
    }
    this.modal.show();
  }

  onHide(): void {
    this.isModalShown = false;
  }

  onGetDate(spliter = '-') {
    return `${this.year}${spliter}${(this.month >= 10) ? this.month : '0' + this.month}${spliter}${(this.day >= 10) ? this.day : '0' + this.day}`;
  }

  convDe_use(de_use) {
    return moment(de_use, 'YYYYMMDD').format('YYYY-MM-DD')
  }

  async onGetUseCredit(f, room: Room) {
    const { rsv_cache } = this
    const { credit_by_time } = rsv_cache

    if (credit_by_time[f.time_use_end]) {
      rsv_cache.credit = credit_by_time[f.time_use_end]
    }
    else if (f.time_use_end) {
      let reservation = new RoomReservation();
      reservation.pblspc_cd = room.cd;
      reservation.de_use = this.onGetDate('');
      reservation.time_use_start = this.startTime
      reservation.time_use_end = this.startTimes[this.startTimeIndex[this.startTime] + this.durationIndex[f.time_use_end]]
      reservation.dtl = f.dtl;
      reservation.memo = '';
      reservation.dong = room.dong
      reservation.se = room.se
      reservation.se_nm = room.se_nm
      reservation.floor = room.floor
      reservation.room = room.room
      reservation.location = this.location;

      try {
        let { credit } = await this.reservationService.getReserveCredit(reservation)
        rsv_cache.credit = credit
        rsv_cache.time_use_end = f.time_use_end
        rsv_cache.credit_by_time[f.time_use_end] = credit
      } catch (error) {
        console.log(error)
      }
    }
  }

  onReserve(f, room: Room) {
    let reservation = new RoomReservation();

    if (!f.time_use_end) {
      window.alert('사용시간을 선택해 주세요.');
      return;
    }

    reservation.pblspc_cd = room.cd;
    reservation.de_use = this.onGetDate('');
    reservation.time_use_start = this.startTime
    reservation.time_use_end = this.startTimes[this.startTimeIndex[this.startTime] + this.durationIndex[f.time_use_end]]
    reservation.dtl = f.dtl;
    reservation.memo = '';
    reservation.dong = room.dong
    reservation.se = room.se
    reservation.se_nm = room.se_nm
    reservation.floor = room.floor
    reservation.room = room.room
    reservation.location = this.location;

    this.reservationService.reserve(reservation).take(1).subscribe(
      res => {
        this.getReservations();
        this.getMyReservation();
        this.modal.hide();

        this.shareService.refreshCredit();
      },
      error => {
        this.getReservations();
        this.getMyReservation();
        this.modal.hide();

        window.alert('회의실을 예약할 수 없습니다.');
      }
    );
  }

  onIsCancel() {
    if (this.authService.isAdmin() ||
      this.reservation.email == this.authService.getEmail())
      return true;

    return false;
  }

  onClickTableCancel(reservation) {
    this.reservation = reservation
    this.onCancel();
  }

  onCancel() {
    let result = window.confirm('회의실 예약을 취소합니다.');
    if (result == true) {
      this.reservationService.cancel(this.reservation.cd).take(1).subscribe(
        res => {
          this.modal.hide();
          this.getReservations();
          this.getMyReservation();
          this.shareService.refreshCredit();

          if (res.crt_count > 0) {
            window.alert(`${res.crt_count} 크레딧이 환급되었습니다.`);
          } else {
            window.alert('크레딧 환급 내역이 없습니다.');
          }
        },
        error => {
          window.alert('회의실 예약을 취소할 수 없습니다.');
          this.modal.hide();
        }
      );
    }
  }

  permitPets = false;
  permitPetsList = [
    'S1121M05006A',
    'S1121M05006B',
    'S1121M06006A',
    'S1121M06006B',
    'S1121M07006A',
    'S1121M07006B',
    'S1121M08006A',
    'S1121M08006B',
    'S1121M10AG12',
    'S1121M10CA14',
    'S1121M10DP09',
    'S1121C10HL80',
    'S1121C10RC06',
    'S1121C10RN28',
    'S1121M040008',
    'S1121M090040', // 추가 9층 10인실, 9층 4인실
    'S1121M090010',
  ]
  calcPermitPets(room: Room) {
    this.permitPets = this.permitPetsList.findIndex(a => a === room.cd) !== -1;
  }

  // 임시 COVID-19 인원 제한 안내문구 추가
  covid19Limits = {
    4: 3,
    6: 4,
    8: 5,
    9: 5,
    10: 6,
    12: 7,
    14: 8,
  }
  getCovid19Limits(bsc_num: number) {
    return null;
    // if (this.covid19Limits.hasOwnProperty(bsc_num)) {
    //   return `코로나-19 확산 방지를 위해 권장 사용 인원을 ${this.covid19Limits[bsc_num]}명으로 제한합니다.`;
    // } else {
    //   return null;
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/member/reservation/rooms/rooms.component.ts